export default __webpack_public_path__ + "static/media/rtr-200-4v.9519962f.svg";